import { Model } from '@/models/Model';
export class ProjectCategory extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'ProjectCategory';
        this.$endpoint = '/project-categories';
        this.$fillable = ['label'];
    }
}
